var _rect, _path, _path2, _circle, _circle2, _circle3, _circle4, _circle5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptycart1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 129,
    viewBox: "0 0 228 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 169,
    y: 37.5,
    width: 14,
    height: 90,
    fill: "#E4F9DB",
    stroke: "#E4F9DB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 71.5H6M9.5 71.5H27.5M19.5 57.5H24.5M28.5 57.5H46M24.5 98V105M21.5 101.5H27.5M189.5 91.5H194.5M198.5 91.5H216M200.5 101H206M209.5 101H227M212.5 53.5H219.5M216 50V57M107 103C112.248 97.8444 114.929 98.6771 119.5 103M41 7V14M37.5 11H44.5",
    stroke: "#256509",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M203.5 128H61M41.5 128H61M61 128V37.5004H110V56.0004M129.5 37.5004H183M88.5 49.0004C81 -10.5002 152.5 -7.5 144 49.0004",
    stroke: "#256509",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 88.5,
    cy: 49,
    r: 3,
    fill: "#256509"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 143.5,
    cy: 49,
    r: 3,
    fill: "#256509"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.5,
    cy: 86,
    r: 3,
    fill: "#256509"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.5,
    cy: 86,
    r: 3,
    fill: "#256509"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 33.5,
    r: 33.5,
    fill: "#E4F9DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptycart1);
export default __webpack_public_path__ + "static/media/emptycart1.424ef5f0f4cf10d31c5c9b682a3d11c7.svg";
export { ForwardRef as ReactComponent };